export const updateHeaderHeight = () => {
  const header = document.querySelector('#header');
  if (header) {
    requestAnimationFrame(() => {
      const headerHeight = header.offsetHeight - 1;
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);

      // side-nav.-other の常時表示バー（アコーディオンを開く前）の高さをCSS変数に設定
      const sideNavBar = document.querySelector('.side-nav.-other .js-side-nav-header');
      if (sideNavBar) {
        document.documentElement.style.setProperty('--side-nav-height', `${sideNavBar.offsetHeight}px`);
      }

      // teacherページのみアンカーリンク時のオフセットを設定
      const isTeacherPage = document.querySelector('.site-wrap.teacher');
      if (isTeacherPage) {
        document.documentElement.style.setProperty('scroll-padding-top', `${headerHeight}px`);
      }
    });
  }
};

export const initUpdateHeaderHeight = () => {
  updateHeaderHeight();

  let resizeTimer;
  window.addEventListener('resize', () => {
    updateHeaderHeight();
    // --side-nav-height（バーの高さ）をリサイズ時に再取得
    const sideNavBar = document.querySelector('.side-nav.-other .js-side-nav-header');
    if (sideNavBar) {
      document.documentElement.style.setProperty('--side-nav-height', `${sideNavBar.offsetHeight}px`);
    }
    // リサイズ中はトランジションを無効化（PC↔SP跨ぎで side-nav が開→閉アニメするのを防ぐ）
    document.documentElement.classList.add('is-resizing');
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      document.documentElement.classList.remove('is-resizing');
    }, 200);
  });
};
